import { emptyValidator, formValidator } from "../../validators";

const policeDivisionValidationStatus = {
  rpoName: {
    validators: [emptyValidator()],
    name: "Police Division Name",
  },
  rpoCountry: {
    validators: [emptyValidator()],
    name: "Country",
  },
};

export const policeDivisionValidation = (policeDivision) => {
  return formValidator(policeDivision, policeDivisionValidationStatus);
};
